import { Platform } from 'react-native';
import useResponsiveness, { XS_BREAKPOINT } from '@/hooks/useResponsiveness';

// Campaigns and promotional composer banners belong only in desktop browsers.
// Check the device as well as width: landscape phones and iPads can be wide.
export function canShowDesktopBanners(width) {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return false;
  if (!((width ?? window.innerWidth) > XS_BREAKPOINT)) return false;

  const nav = window.navigator || {};
  const ua = nav.userAgent || '';
  if (nav.userAgentData?.mobile || /Mobi|Android|iPhone|iPad|iPod/i.test(ua)) return false;
  if (/Macintosh/i.test(ua) && (nav.maxTouchPoints || 0) > 1) return false;
  if (window.matchMedia?.('(pointer: coarse)').matches
      && !window.matchMedia?.('(any-pointer: fine)').matches) return false;

  return true;
}

export default function useDesktopBanners() {
  const { windowWidth } = useResponsiveness();
  return canShowDesktopBanners(windowWidth);
}
